import React from "react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { HardDrive, ChevronLeft, Info } from "lucide-react";

export default function BackupPlaceholder() {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <Link to="/settings" className="text-slate-500 hover:text-slate-700"><ChevronLeft className="h-5 w-5" /></Link>
        <HardDrive className="h-6 w-6 text-blue-600" />
        <h1 className="font-heading text-2xl font-semibold">Backup</h1>
      </div>
      <Card className="p-6 border-amber-200 bg-amber-50 flex items-start gap-3">
        <Info className="h-5 w-5 text-amber-600 mt-0.5 shrink-0" />
        <div className="text-sm text-amber-900">
          <div className="font-semibold">Funzionalità disponibile dallo Sprint 7.</div>
          <div className="mt-1">Quando sarà attiva, qui troverai la configurazione dei backup automatici su Dropbox, lo storico delle esportazioni e il ripristino.</div>
        </div>
      </Card>
    </div>
  );
}
